module.exports = {
    ATPayinTax: require('./Policy/ATPayinTax'),
    BAPayinTax: require('./Policy/BAPayinTax'),
    BAPayoutTax: require('./Policy/BAPayoutTax'),
    BARSRetailBettingPayoutTax:require('./Policy/BARSRetailBettingPayoutTax'),
    BARSRetailGamesPayoutTax: require('./Policy/BARSRetailGamesPayoutTax'),
    BARSWebBettingPayoutTax: require('./Policy/BARSWebBettingPayoutTax'),
    BARSWebGamesPayoutTax: require('./Policy/BARSWebGamesPayoutTax'),
    CZPayoutTax: require('./Policy/CZPayoutTax'),
    DEPayinTax: require('./Policy/DEPayinTax'),
    ETPayinTax: require('./Policy/ETPayinTax'),
    ETPayoutTax: require('./Policy/ETPayoutTax'),
    KEPayinTax: require('./Policy/KEPayinTax'),
    KEPayoutTax: require('./Policy/KEPayoutTax'),
    MKPayoutTax: require('./Policy/MKPayoutTax'),
    PLPayinTax: require('./Policy/PLPayinTax'),
    PLPayoutTax: require('./Policy/PLPayoutTax'),
    ROPayinTax: require('./Policy/ROPayinTax'),
    ROPayoutTax: require('./Policy/ROPayoutTax'),
    ROSuperbetPayinTax: require('./Policy/ROSuperbetPayinTax'),
    ROSuperbetPayoutTax: require('./Policy/ROSuperbetPayoutTax'),
    RWPayoutTax: require('./Policy/RWPayoutTax'),
    SIPayinTax: require('./Policy/SIPayinTax'),
    SIPayoutTax: require('./Policy/SIPayoutTax'),
    SKPayinTax: require('./Policy/SKPayinTax'),
    TZPayinTax: require('./Policy/TZPayinTax'),
    TZPayoutTax: require('./Policy/TZPayoutTax'),
    UGPayoutTax: require('./Policy/UGPayoutTax')
};
